export function buildHourlySeriesFromMinuteArray(arr, tuneOut = false) {
  const minutes = Array.isArray(arr) ? arr : [];

  const corrected = minutes.map((v) =>
    v != null ? (tuneOut ? Math.round(Number(v) / 2) : Number(v)) : 0
  );

  return Array.from({ length: 24 }, (_, h) => {
    const slice = corrected.slice(h * 60, h * 60 + 60);
    const sum = slice.reduce((a, b) => a + (Number(b) || 0), 0);

    return {
      label: `${String(h).padStart(2, "0")}:00`,
      value: sum,
    };
  });
}
